import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../../PanelPage";
import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {Messages} from "../../../../../Messages";
import {LinkButton} from "../../../../../../core/ui/LinkButton.jsx";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {Flow} from "../../../../flows/FlowState.js";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {MessageElement} from "../../../../../widget/ui/MessageElement";


export class CancelDonationPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.donatePageCancelDonationTitle,
        };
    }

    render() {
        const {styleSheet} = this;
        const merchantName = iFrameMerchantService.getMerchant().name;

        return [
            <MessageElement message={Messages.donatePageCancelDonationText1(merchantName)}/>,
            <MessageElement message={Messages.donatePageCancelDonationText2(merchantName)}/>,
            <MerchantButton onClick={() => Flow.donation.cancel()}
                            className={styleSheet.actionButton}>
                {Messages.donatePageCancelDonationButton}
            </MerchantButton>,
            <LinkButton
                value={Messages.back}
                className={styleSheet.backButton}
                onClick={() => Router.back()}
            />
        ];
    }
}
